import { render, staticRenderFns } from "./c-items-per-page-field.vue?vue&type=template&id=6547e2ce&scoped=true&"
import script from "./c-items-per-page-field.vue?vue&type=script&lang=js&"
export * from "./c-items-per-page-field.vue?vue&type=script&lang=js&"
import style0 from "./c-items-per-page-field.vue?vue&type=style&index=0&id=6547e2ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6547e2ce",
  null
  
)

export default component.exports